"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToNumKey = void 0;
var operators_1 = require("rxjs/operators");
var filter_key_is_down_1 = require("../filter-key-is-down");
var filter_keys_in_list_1 = require("../filter-keys-in-list");
var mapToNumKey = function () { return function (keyEvent$) {
    return keyEvent$.pipe((0, filter_keys_in_list_1.filterKeyInList)(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']), (0, filter_key_is_down_1.filterKeyIsDown)(), (0, operators_1.map)(function (ev) { return Number(ev.key); }));
}; };
exports.mapToNumKey = mapToNumKey;
